import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpDeviceConnection } from "../models/dw"
import { ColumnInfo, DeviceConnectionMarkerIcon } from "../models/custom"

export class DataProviderDeviceConnection {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public getDeviceConnectionFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpDeviceConnection>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdDeviceConnection, 'OpxDeviceConnectionFilter', 'OpxDeviceConnectionFilterResult')
    }

    public deviceConnectionMapMarkerConfiguration = (): JQueryPromise<DeviceConnectionMarkerIcon[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxDeviceConnectionMapMarkerConfiguration', {}, 'OpxDeviceConnectionMapMarkerConfigurationResult')
            .then((data: any[]) => {
                const result: DeviceConnectionMarkerIcon[] = data.map((x: any) => new DeviceConnectionMarkerIcon(x))

                return DeviceConnectionMarkerIcon.loadNavigationProperties(this.dataProvider, result)
            })
    }

    // Public Methods End
}